module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page"
  }, [_c('page-header', {
    attrs: {
      "header": _vm.title
    }
  }), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card contents"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h3', {
    staticClass: "contents-header"
  }, [_vm._v("Contents")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('ul', [_c('li', [_c('div', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/watch?v=C6-qCnIsNjs"
    }
  }, [_vm._v("Program Goals, Objectives and Performance Indicators")]), _vm._v("  »")])]), _vm._v(" "), _c('li', [_c('div', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/watch?v=rop6xoEA_NQ"
    }
  }, [_vm._v("The Value of Logic Models (Part 1)")]), _vm._v("  »")])]), _vm._v(" "), _c('li', [_c('div', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/watch?v=1bGkwPgwmcw"
    }
  }, [_vm._v("Major Components of a Logic Model (Part 2)")]), _vm._v("  »")])]), _vm._v(" "), _c('li', [_c('div', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/watch?v=6O5YP5d2iTs"
    }
  }, [_vm._v("How Logic Models Support Implementation (Part 3)")]), _vm._v("  »")])]), _vm._v(" "), _c('li', [_c('div', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/watch?v=iHsWphZtbzU"
    }
  }, [_vm._v("Amendments to Grant Agreements")]), _vm._v("  »")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('ul', [_c('li', [_c('div', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/watch?v=YjkFmPid5DI"
    }
  }, [_vm._v("Budget Categories Needing Prior Approval")]), _vm._v("  »\n          ")])]), _vm._v(" "), _c('li', [_c('div', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/watch?v=nQb8pK5e3Mo"
    }
  }, [_vm._v("Budget Category: Travel Costs")]), _vm._v("  »\n          ")])]), _vm._v(" "), _c('li', [_c('div', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/watch?v=zXIopZ4KeEI"
    }
  }, [_vm._v("Budget Category: Subcontractors")]), _vm._v("  »\n          ")])]), _vm._v(" "), _c('li', [_c('div', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/watch?v=4stkASoNY5w"
    }
  }, [_vm._v("Budget Category: Indirect Costs")]), _vm._v("  »\n          ")])]), _vm._v(" "), _c('li', [_c('div', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/watch?v=x6cqf0075Fg"
    }
  }, [_vm._v("Faith-Based Program Self Reporting Form")]), _vm._v("  »\n          ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card well",
    attrs: {
      "id": "program-goals"
    }
  }, [_c('h2', {
    staticClass: "h4"
  }, [_vm._v("Program Goals, Objectives and Performance Indicators")]), _vm._v(" "), _c('p', [_vm._v("View a webinar describing Goals, Objectives, and Performance\n  Indicators to assist in the process of grant and program development.")]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "width": "16rem",
      "margin-left": "auto",
      "margin-right": "auto"
    }
  }, [_c('span', {
    staticClass: "card-img-top youtube",
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "id": "C6-qCnIsNjs",
      "alt": "Card image cap"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Added April 2017")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card well",
    attrs: {
      "id": "logic-models"
    }
  }, [_c('h2', {
    staticClass: "h4"
  }, [_vm._v("Logic Models")]), _vm._v(" "), _c('p', [_vm._v("View this Logic Model webinar series to assist in the process of program planning and development.")]), _vm._v(" "), _c('div', {
    staticClass: "card-deck text-center",
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    }
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "width": "15rem"
    }
  }, [_c('span', {
    staticClass: "card-img-top youtube",
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "id": "rop6xoEA_NQ",
      "alt": "Card image cap"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("The Value of Logic Models (Part 1)")])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Added April 2017")])])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "width": "15rem"
    }
  }, [_c('span', {
    staticClass: "card-img-top youtube",
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "id": "1bGkwPgwmcw",
      "alt": "Card image cap"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Major Components of a Logic Model (Part 2)")])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Added April 2017")])])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "width": "15rem"
    }
  }, [_c('span', {
    staticClass: "card-img-top youtube",
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "id": "6O5YP5d2iTs",
      "alt": "Card image cap"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("How Logic Models Support Implementation (Part 3)")])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Added April 2017")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card well",
    attrs: {
      "id": "amendments"
    }
  }, [_c('h2', {
    staticClass: "h4"
  }, [_vm._v("Amendments to Grant Agreements")]), _vm._v(" "), _c('p', [_vm._v("View a webinar on the process of amending an existing Authority grant agreement.\n")]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "width": "16rem",
      "margin-left": "auto",
      "margin-right": "auto"
    }
  }, [_c('span', {
    staticClass: "card-img-top youtube",
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "id": "iHsWphZtbzU",
      "alt": "Card image cap"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Added April 2017")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card well",
    attrs: {
      "id": "prior-approval"
    }
  }, [_c('h2', {
    staticClass: "h4"
  }, [_vm._v("Budget Categories Needing Prior Approval")]), _vm._v(" "), _c('p', [_vm._v("View a webinar describing items that require Prior Approvals and/or Additional Justifications (even if they are detailed in the agreement narrative and budget).\n ")]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "width": "16rem",
      "margin-left": "auto",
      "margin-right": "auto"
    }
  }, [_c('span', {
    staticClass: "card-img-top youtube",
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "id": "YjkFmPid5DI",
      "alt": "Card image cap"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Added April 2017")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card well",
    attrs: {
      "id": "travel-costs"
    }
  }, [_c('h2', {
    staticClass: "h4"
  }, [_vm._v("Budget Category: Travel Costs")]), _vm._v(" "), _c('p', [_vm._v("View a webinar describing Travel Costs and State Travel Guidelines.\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "width": "16rem",
      "margin-left": "auto",
      "margin-right": "auto"
    }
  }, [_c('span', {
    staticClass: "card-img-top youtube",
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "id": "nQb8pK5e3Mo",
      "alt": "Card image cap"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Added April 2017")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card well",
    attrs: {
      "id": "subcontractors"
    }
  }, [_c('h2', {
    staticClass: "h4"
  }, [_vm._v("Budget Category: Subcontractors")]), _vm._v(" "), _c('p', [_vm._v("This webinar describes the Subcontract Approval process and\n     required Consultant/Contractor/Vendor documentation.\n\n   ")]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "width": "16rem",
      "margin-left": "auto",
      "margin-right": "auto"
    }
  }, [_c('span', {
    staticClass: "card-img-top youtube",
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "id": "zXIopZ4KeEI",
      "alt": "Card image cap"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Added April 2017")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card well",
    attrs: {
      "id": "indirect-costs"
    }
  }, [_c('h2', {
    staticClass: "h4"
  }, [_vm._v("Budget Category: Indirect Costs")]), _vm._v(" "), _c('p', [_vm._v("View a webinar on Indirect Costs.\n\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "width": "16rem",
      "margin-left": "auto",
      "margin-right": "auto"
    }
  }, [_c('span', {
    staticClass: "card-img-top youtube",
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "id": "4stkASoNY5w",
      "alt": "Card image cap"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Added April 2017")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card well",
    attrs: {
      "id": "self-reporting"
    }
  }, [_c('h2', {
    staticClass: "h4"
  }, [_vm._v("Faith-Based Program Self Reporting Form")]), _vm._v(" "), _c('p', [_vm._v("View a webinar on how to complete the Authority's Faith-Based Program Self Reporting Form.\n\n     ")]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "width": "16rem",
      "margin-left": "auto",
      "margin-right": "auto"
    }
  }, [_c('span', {
    staticClass: "card-img-top youtube",
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "id": "x6cqf0075Fg",
      "alt": "Card image cap"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Added April 2017")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a25b014"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Webinars.vue
// module id = 371
// module chunks = 0